import React, { useCallback } from 'react';
import PropTypes from 'prop-types';
import { useSelector } from 'react-redux';
import I18n from 'i18n-js';
import { Button } from 'grab-ui';
import instrumentationDuck from 'ducks/instrumentation-duck';
import scribeTrack from 'scribe/scribe-track';
import { inGrabApp } from 'common/utils/platform';
import styles from './order-id.less';
import useClipBoard from '../../hooks/useClipBoard';
import copySvg from '../../public/images/copy.svg';
import checkedRoundSvg from '../../public/images/checked-round.svg';

const CopiedIndicator = () => (
  <div className={styles.copiedIndicator}>
    <span>{I18n.t('orderId.copied')}</span>
    <img src={checkedRoundSvg} alt="checked" />
  </div>
);

const OrderId = ({ id }) => {
  const { orderId, trackingPageType, trackingSource } = useSelector(
    instrumentationDuck.selectors.instrumentation,
  );
  const { copy, hasCopied } = useClipBoard(id);

  const sendInstrumentation = useCallback(
    () => {
      scribeTrack.expressTracking.copy({
        trackingSource,
        orderIdDisplayed: orderId,
        isInApp: inGrabApp(),
        trackingPageType,
      });
    },
    [orderId, trackingPageType, trackingSource],
  );

  const copyId = useCallback(
    () => {
      sendInstrumentation();
      copy(id);
    },
    [id, copy, sendInstrumentation],
  );

  return (
    <div className={styles.container}>
      <p className={styles.idLabel}>{id}</p>

      {hasCopied ? (
        <CopiedIndicator />
      ) : (
        <Button
          className={styles.copyBtn}
          onClick={copyId}
          disabled={hasCopied}
        >
          <img src={copySvg} alt="copy" />
        </Button>
      )}
    </div>
  );
};

OrderId.propTypes = {
  id: PropTypes.string.isRequired,
};

export default OrderId;
